import { Box, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

export default function FormSubsection({ children, title }) {
    return (
        <Box>
        { title && <Typography className="title-subsection" sx={{ pl: '1em' }}>{title}</Typography> }
        <Stack spacing={4}>
            { children }
        </Stack>
        </Box>
    )
}